import { AxiosResponse } from "axios";
import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage, setExpiresDate } from "helpers";
import { fusionAuthService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";


type UseFusionAuthTokenMutationType = {
	onSuccess?: () => void;
	onError?: () => void;
};

const useFusionAuthTokenMutation = ({
	onSuccess,
	onError,
}: UseFusionAuthTokenMutationType = {}) => {
	const dispatch = useDispatch();

	return useMutation(
		({
			authCode,
			redirectToPath,
		}: {
			authCode: string;
			redirectToPath?: string | null;
		}) => {
			dispatch(uiActions.showSpinnerOverlay(false));

			return fusionAuthService.getTokens(authCode, redirectToPath);
		},
		{
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
			onSuccess(res: AxiosResponse) {
				onSuccess?.();
				setExpiresDate(res.data);
			},
			onError(error: ErrorResponse) {
				onError?.();
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			retry: 3,
			retryDelay: 1000,
		},
	);
};

export default useFusionAuthTokenMutation;
